export default function (interceptors) {
  interceptors.response.use(response => response, error => error.response);
}



// WEBPACK FOOTER //
// ./src/services/interceptors/response-interceptor.js